<template>
  <section class="container">
    <div class="row">
      <div class="col">
        <div class="chat-page">
          <div class="tabs">
            <button class="tab" :class="{ active: activeTab === 'all' }" @click="changeTab('all')">All</button>
            <button class="tab" :class="{ active: activeTab === 'unread' }" @click="changeTab('unread')">Unread</button>
            <button class="tab" :class="{ active: activeTab === 'online' }" @click="changeTab('online')">Online</button>
          </div>

          <!-- Passa o status como prop para filtrar os chats -->
          <ChatList :status="activeTab" @openChat="openChat" />

          <!-- Display chat window if user selects a conversation -->
          <div v-if="selectedChat" class="chat-window">
            <ChatWindow :chat="selectedChat" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import ChatList from '@/components/ChatList.vue';
import ChatWindow from '@/components/ChatWindow.vue';

const activeTab = ref('all');  // Estado para controlar a aba ativa
const selectedChat = ref(null);  // Estado para armazenar o chat selecionado

// Função para alterar a aba
const changeTab = (tab) => {
  activeTab.value = tab;
  selectedChat.value = null;  // Reseta o chat selecionado ao mudar de aba
};

// Função para abrir o chat ao clicar
const openChat = (chat) => {
  selectedChat.value = chat;
};
</script>

<style scoped>
.chat-page {
  display: flex;
  flex-direction: column;
}

.tabs {
  display: flex;
  justify-content: space-around;
  background: #f1f1f1;
}

.tab {
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
}

.tab.active {
  background: #007bff;
  color: white;
}

.chat-window {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>